import PublicEvent from './PublicEvent.js';

class StfuEvent extends PublicEvent {
  handle() {
    this.context._rtConnection.send({ message: 'stfu' });
  }
}

export default StfuEvent;
